<template>
<v-card outlined>
    <v-card-title class="primary--text text-h6">
        {{name}}
    </v-card-title>
    <v-list dense>
        <v-list-item v-for="phone in phones" :key="phone.id">
            <v-list-item-icon>
                <v-icon color="primary">
                    mdi-phone
                </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{phone.number}}</v-list-item-title>
                <v-list-item-subtitle>
                    <v-chip class="mx-1" x-small v-for="cat in categories(phone.class)" :key="cat">
                        {{cat}}
                    </v-chip>
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="email">
            <v-list-item-icon>
                <v-icon color="primary">
                    mdi-email
                </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{email}}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item>
            <v-list-item-icon>
                <v-icon color="primary">
                    mdi-badge-account
                </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>
                    <router-link :to="salesPerson ? `/sales/sales-person/${salesPerson.id}` : ''">{{salesPerson ? salesPerson.name : "No Sales Person"}}</router-link>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</v-card>
</template>

<script>
export default {
    name: "CustomerInfo",
    props: [
        "name", "phones", "email", "salesPerson"
    ],
    data() {
        return {
            phoneClasses: [{
                    text: "Calls",
                    value: 1
                },
                {
                    text: "SMS",
                    value: 2
                },
                {
                    text: "App",
                    value: 3
                }
            ]
        }
    },
    methods: {
        categories(classes) {
            let array = [];
            classes.forEach(id => {
                let phoneClass = this.phoneClasses.find(phoneClass => phoneClass.value == id);
                let name = phoneClass.text;
                array.push(name);
            });
            return array;
        }
    }
}
</script>
